import { Rocket } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";

import { getPackageHref } from "app/common/hrefs";
import { swSettings } from "app/common/services/swSettings";
import { translate } from "app/filters/i18nFilter";
import { headerDataAutomation } from "app/pages/activation/components/HomeWithData/dataAutomationKeys";
import { allTrackers } from "app/services/track/track";
import { isNoTouch, isSI } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

export const ExplorePlansButton = () => {
    if (!isNoTouch(swSettings) || isSI(swSettings)) {
        return null;
    }

    const handleClick = (): void => {
        allTrackers.dispatchTrackEvent("Button", "click", "explore plans button");
        window.open(getPackageHref());
    };

    return (
        <Tooltip
            content={translate("marketing.components.explore_plans_button.tooltip")}
            placement="bottom"
        >
            <Rocket
                color={colorsPalettes.blue[400]}
                onClick={handleClick}
                size="sm"
                cursor="pointer"
                data-automation={headerDataAutomation.rocketIcon}
            />
        </Tooltip>
    );
};
